import { Template } from '@/interfaces/template';
import { TemplateResource, templateResource } from '@/resources/template.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł wzoru procedury
 *
 * @export
 * @class TemplateModule
 * @extends {EntityModule<Template, TemplateResource>}
 */
export class TemplateModule extends EntityModule<Template, TemplateResource> {
  constructor() {
    super(templateResource);
  }
}

export default new TemplateModule();
